module.exports = __webpack_public_path__ + "static/img/icon_dec.2a652bec.png";